// extracted by mini-css-extract-plugin
module.exports = {"Container":"Adminstration_Container__3dFa4","NoUsers":"Adminstration_NoUsers__1eq0j"};